function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("circle", {
  opacity: 0.1,
  cx: 18,
  cy: 18.5,
  r: 18,
  fill: "#758596"
}), React.createElement("g", {
  clipPath: "url(#clip1)"
}, React.createElement("path", {
  d: "M17.9783 8.32979C19.2592 8.32979 20.2656 9.33617 20.2656 10.617C20.2656 11.8979 19.2592 12.9043 17.9783 12.9043C16.6975 12.9043 15.6911 11.8979 15.6911 10.617C15.6911 9.33617 16.6975 8.32979 17.9783 8.32979ZM17.9783 6.5C15.6911 6.5 13.8613 8.32979 13.8613 10.617C13.8613 12.9043 15.6911 14.734 17.9783 14.734C20.2656 14.734 22.0954 12.9043 22.0954 10.617C22.0954 8.32979 20.2656 6.5 17.9783 6.5Z",
  fill: "#758596"
}), React.createElement("path", {
  d: "M24.8397 21.5957C26.1205 21.5957 27.1269 22.602 27.1269 23.8829C27.1269 25.1637 26.1205 26.1701 24.8397 26.1701C23.5588 26.1701 22.5524 25.1637 22.5524 23.8829C22.5524 22.602 23.5588 21.5957 24.8397 21.5957ZM24.8397 19.7659C22.5524 19.7659 20.7227 21.5957 20.7227 23.8829C20.7227 26.1701 22.5524 27.9999 24.8397 27.9999C27.1269 27.9999 28.9567 26.1701 28.9567 23.8829C28.9567 21.5957 27.1269 19.7659 24.8397 19.7659Z",
  fill: "#758596"
}), React.createElement("path", {
  d: "M11.117 21.5957C12.3979 21.5957 13.4043 22.602 13.4043 23.8829C13.4043 25.1637 12.3979 26.1701 11.117 26.1701C9.83617 26.1701 8.82979 25.1637 8.82979 23.8829C8.82979 22.602 9.83617 21.5957 11.117 21.5957ZM11.117 19.7659C8.82979 19.7659 7 21.5957 7 23.8829C7 26.1701 8.82979 27.9999 11.117 27.9999C13.4043 27.9999 15.234 26.1701 15.234 23.8829C15.234 21.5957 13.4043 19.7659 11.117 19.7659Z",
  fill: "#758596"
}), React.createElement("path", {
  d: "M17.9785 19.217V14.1851",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M13.6777 21.5958L17.9777 19.217",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M22.2785 21.5958L17.9785 19.217",
  stroke: "#758596",
  strokeWidth: 2,
  strokeMiterlimit: 10
})));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "white",
  transform: "translate(0 0.5)"
})), React.createElement("clipPath", {
  id: "clip1"
}, React.createElement("rect", {
  width: 21.9574,
  height: 21.5,
  fill: "white",
  transform: "translate(7 6.5)"
})));

var SvgDistribute = function SvgDistribute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDistribute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/distribute.fe796bbd.svg";
export { ForwardRef as ReactComponent };